import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Select } from 'antd';
import GridContainer from '../global/GridContainer/GridContainer';
import AuntyItem from './components/AuntyItem';
import { GenderApi } from '../../api';
import FilterIcon from '../../assets/images/filter.svg';

const AskAuntyOrUncle = ({ aunties, getAunties }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState([]);
  const [gender, setGender] = useState([])

  useEffect(() => {
    getAunties({});

    GenderApi.getGender().then((data) => {
      const genderOptions = data.genderList.filter((item) => item.id !== 'prefer-not-to-say')

      genderOptions.unshift({
        id: 'all',
        name: "All"
      })

      setGender(genderOptions)
    })
  }, []);

  const onSearch = (searchText) => {
    if (searchText === "all") {
      getAunties({});
      setSearch([]);
    } else {
      getAunties({ gender: searchText });
      setSearch(searchText);
    }
  };

  return (
    <div className="aunties-container">
      <GridContainer>
        <div className="aunties-container--upper">
          <div className="aunties-container-header-back-link" onClick={() => navigate('/home')}>
            <FontAwesomeIcon
              icon={['fas', 'chevron-left']}
              className="feed-group-header-back-link-icon"
            />
            {'Go back'}
          </div>
          <h3 className="title m-0">Ask Aunty or Uncle</h3>
        </div>
        <div className="aunties-container-hub-list pt-4">
          <div className="d-flex w-100 align-items-center pb-3">
            <img width="20" height="18" src={FilterIcon} alt="filter icon" />
            <p className="aunties-container-filter-title pr-1 pl-1">Filter by</p>
            <Select onChange={onSearch} value={search} placeholder="Gender" className="aunties-container-filter-select">
                {gender.map((item) => {
                  return (
                    <Select.Option value={item.id}>
                     <div className="aunties-select-dropdown-item p-1">
                        {item.name}
                     </div>
                    </Select.Option>
                  )
                   
                } )}
            </Select>
          </div>
          {aunties.map((aunty) => {
            return (
              <AuntyItem
                id={aunty.id}
                imageId={aunty.image_id}
                imageData={aunty.image}
                firstName={aunty.first_name}
                lastName={aunty.last_name}
                religion={aunty.religion}
                nationality={aunty.nationality}
                gender={aunty.gender}
              />
            );
          })}
          {!aunties.length && !search ? (
            <p>No aunties available at the moment.</p>
          ) : null}
          {!aunties.length && search ? <p>No Aunties or Uncles match your selection at the moment.</p> : null}
        </div>
      </GridContainer>
    </div>
  );
};

export default AskAuntyOrUncle;
